<template>
  <v-dialog 
    v-model="activeMode"  
    max-width="800"
    @click:outside="closeForm()"
    :fullscreen="$vuetify.breakpoint.smAndDown"
  >
    <template v-slot:activator="{ on }">
      <a v-on="on">{{ value.id }} <v-icon small>mdi-launch</v-icon></a>
    </template>

    <v-card>
      <v-toolbar
        color="primary"
        dark
        flat
      >
        <v-toolbar-title>Карточка дома № {{ value.id }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeForm()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-card class="mt-3">
          <v-card-title>{{ value.name }}</v-card-title>
          <v-card-text>
            <div v-if="value.photo1" style="text-align:center;">
              <img :src="value.photo1.mediumImageUrl" style="width: 400px;">
            </div>
            <p v-if="value.address"><strong>Адрес дома:</strong> {{ value.address }}</p>
            <p v-if="value.company"><strong>Застройщик:</strong> {{ value.company }}</p>
            <p v-if="value.object"><strong>ЖК:</strong> {{ value.object }}</p>
            <p v-if="value.declaration"><strong>Декларация:</strong> {{ value.declaration }}</p>
            <p v-if="value.floors"><strong>Этажность:</strong> {{ value.floors }}</p>
            <p v-if="value.flats"><strong>Число квартир:</strong> {{ value.flats }}</p>
            <p v-if="value.finish"><strong>Срок сдачи:</strong> {{ value.finish }}</p>
            <p v-if="value.escrow"><strong>Продажа через эскроу:</strong> да</p>
            <p v-if="value.guarantee"><strong>Продажа квартир с гарантиями Фонда:</strong> да</p>
            <p v-if="value.problems"><strong>Дом признан проблемным:</strong> да</p>
            <p v-if="value.segment"><strong>Класс недвижимости:</strong> {{ value.segment }}</p>
            <p v-if="value.walls"><strong>Материал стен:</strong> {{ value.walls }}</p>
            <p v-if="value.finishing"><strong>Тип отделки:</strong> {{ value.finishing }}</p>
            <p v-if="value.freeplan"><strong>Свободная планировка:</strong> {{ value.freeplan }}</p>
            <p v-if="value.parking"><strong>Число парковочных мест:</strong> {{ value.parking }}</p>
            <p v-if="value.square"><strong>Жилая площадь:</strong> {{ value.square }} м2</p>
          </v-card-text>
        </v-card>
      </v-card-text>

    </v-card>
  </v-dialog>

</template>

<script>
export default {
  name: 'building-card',
  
  props: {
    value: Object
  },

  data() {
    return {
      activeMode: false,
    }
  },
  methods: {
    closeForm() {
      this.activeMode = false;
    }
  }
}
</script>